<!--<div>{{errorMsg}}</div>-->
<!--<button class="btn btn-default" type="button" (click)="export()">Export</button>-->
<dx-data-grid id="gridContainer"
              [dataSource]="recsresults"
              keyExpr="PlanID"
              (onInitialized)="onInitialized($event)"
              [showBorders]="true"
              (onCellClick)="imgClicked($event)"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [columnMinWidth]="75">

  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-selection mode="single"></dxo-selection>
  <dxo-scrolling mode="virtual" columnRenderingMode="virtual"></dxo-scrolling>
  <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="false"></dxo-grouping>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-filter-row [visible]="showFilterRow"
                  [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-paging [enabled]="false"></dxo-paging>

  <dxi-column dataField="fileDate"
              dataType="date"
              format="MM/dd/yyyy"
              caption="Date">
  </dxi-column>
  <!--  <dxi-column caption="Name">
    </dxi-column>-->
  <dxi-column dataField="owner"
              caption="Owner">
  </dxi-column>

  <dxi-column caption="Role">
  </dxi-column>
  <dxi-column dataField="description"
              caption="Description">
  </dxi-column>
  <dxi-column dataField="town"
              caption="Town">
  </dxi-column>

  <dxi-column dataField="PlanID"
              caption="Plan No.">
  </dxi-column>

  <dxi-column [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              [width]="50">
  </dxi-column>

  <div *dxTemplate="let row of 'cellTemplate'">
    <a href="javascript:;" (click)="openImage($event, row.data.PlanID, row.data.book, row.data.page, row.data.fileDate)" class="image">
      <img src="images/document-icon-blue.png" />
    </a>
  </div>


  <!--<div *dxTemplate="let row of 'cellTemplate'">
    <!--Opens image in another tab of a browser on image click-->
  <!--<a target="_blank" [routerLink]='["/rec-plan-name-doc-disp-pg", row.data.book, row.data.page, "Recorded"]' class="image">
    <img src="images/document-icon-blue.png" />
  </a>
  </div>-->
  <!--  <div *dxTemplate="let row of 'cellTemplate'">
      <!--Opens image in another tab of a browser on image click
      <a target="_blank" [routerLink]='["/rec-plan-bp-doc-disp-pg", row.data.book, row.data.page, row.data.bookType]' class="image">
        <img src="images/document-icon-blue.png" />
      </a>
    </div> -->

</dx-data-grid>

